<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2018-->

<!-- Main nexleader-wrapper -->
<app-nexleader-wrapper-panel>
  <app-nexleader-sessions
    *ngIf="coachUser"
    [coachUser]="coachUser"
  ></app-nexleader-sessions>
</app-nexleader-wrapper-panel>
